<template>
    <div class="scheduler-wrapper">
        <datetime ref="datePicker"
                  v-on:input="emitDate"
                  :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                  v-on:close="emitClose"
                  type="datetime"
                  v-model="date"
                  value-zone="Europe/Amsterdam"
                  auto></datetime>
    </div>
</template>

<script>
    import { Datetime } from 'vue-datetime';

    export default {
        name: 'DateTimePickerWrapper',

        components: {
            datetime: Datetime,
        },

        props: {
            date: {
                required: true
            }
        },

        methods: {
            emitDate(date) {
                if(date) {
                    this.$emit('datePicked', date);
                }
            },

            emitClose() {
                this.$emit('closed');
            }
        },

        mounted() {
            this.$refs.datePicker.$el.firstElementChild.click();
        }
    }
</script>

<style lang="scss">
    .scheduler-wrapper {
        bottom: calc(100% + 10px);

        input {
            display: none;
            font-size: 13px;
            box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
            color: #fff;
            font-weight: 600;
            border: 0;
            border-radius: 10px;
            background: #3c3c3c;

            &:hover {
                cursor: pointer;
            }
        }

        &.show {
            input {
                display: block;
            }
        }
    }
</style>